import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Text from './Text';
import Icon from './Icon';
import { palette, flexColumn } from '../../constants/styles';
import CTAButton from './CTAButton';
import { getCampaign } from '../../constants/utils';
import Title from './Title';

const Container = styled.div`
  ${flexColumn}
  ${({ styles }) => styles};
`;

const StyledSecondaryValuePropCTA = css`
  width: 100%;
  height: 100%;
  background-color: white;
  color: ${palette.primaryColor};
  border: 1px solid ${palette.primaryColor};
  margin-right: 5px;

  &:hover {
    background-color: rgba(2, 39, 89, 0.05);
  }
`;

const FinalCTA = css`
  width: 100%;
  height: 100%;
  margin-right: 5px;

  &:hover {
    background-color: ${palette.primaryOpacity};
  }
`;

const GetStartedWithExample = ({
  title,
  subtitle,
  exampleText,
  ctaText,
  exampleInternalLink,
  ctaInternalLink,
  exampleExternalLink,
  ctaExternalLink,
  styles,
}) => (
  <Container styles={styles}>
    <Title
      level={2}
      styles={css`
        margin-top: 0px;
        margin-bottom: 10px;
      `}
      align="center"
      color={palette.secondaryColor}
    >
      {title}
    </Title>
    <Text
      type="body1"
      styles={css`
        line-height: 1.5;
      `}
    >
      {subtitle}
    </Text>
    <CTAButton
      internalLink={exampleInternalLink}
      externalLink={exampleExternalLink}
      buttonText={exampleText}
      buttonStyles={StyledSecondaryValuePropCTA}
      linkStyles={css`
        width: 100%;
        height: 40px;
        margin-top: 10px;
        margin-bottom: 10px;
      `}
      event={`[${getCampaign(window.location.href)}] | Retiro | 73 | ${exampleText}`}
    />
    <CTAButton
      internalLink={ctaInternalLink}
      externalLink={ctaExternalLink}
      buttonText={ctaText}
      buttonStyles={FinalCTA}
      linkStyles={css`
        width: 100%;
        height: 40px;
      `}
      event={`[${getCampaign(window.location.href)}] | Retiro | 73 | ${ctaText}`}
    />
  </Container>
);

GetStartedWithExample.propTypes = {
  bullets: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  exampleText: PropTypes.string,
  ctaText: PropTypes.string,
  exampleInternalLink: PropTypes.string,
  ctaInternalLink: PropTypes.string,
  exampleExternalLink: PropTypes.string,
  ctaExternalLink: PropTypes.string,
};

GetStartedWithExample.defaultProps = {
  bullets: [],
  title: '',
  subtitle: '',
  exampleText: '',
  ctaText: '',
  exampleInternalLink: '',
  ctaInternalLink: '',
  exampleExternalLink: '',
  ctaExternalLink: '',
};

export default GetStartedWithExample;
